<template>
  <b-modal ref="modal" hide-footer title="Search" size="lg">
    <b-form @submit="onSubmit" @reset="onReset" class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <b-form-group label="Company Name:" label-for="companyName">
          <b-form-input id="companyName" v-model="form.companyName" type="text">
          </b-form-input>
        </b-form-group>

        <b-form-group label="Vendor:" label-for="vendor">
          <b-form-input id="vendor" v-model="form.vendor" type="text">
          </b-form-input>
        </b-form-group>

        <b-form-group label="Company Number:" label-for="companyNumber">
          <b-form-input
            id="companyNumber"
            v-model="form.companyNumber"
            type="text"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group label="Telephone Number:" label-for="telephoneNumber">
          <b-form-input
            id="telephoneNumber"
            v-model="form.telephoneNumber"
            type="text"
          >
          </b-form-input>
        </b-form-group>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <b-form-group label="Postcode:" label-for="postcode">
          <b-form-input id="postcode" v-model="form.postcode" type="text">
          </b-form-input>
        </b-form-group>

        <b-form-group label="Email Address:" label-for="emailAddress">
          <b-form-input
            id="emailAddress"
            v-model="form.emailAddress"
            type="email"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group label="Status:" label-for="status">
          <b-form-select
            v-if="lookups"
            id="status"
            v-model="form.status"
            :options="statuses"
            value-field="id"
            text-field="name"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="Tier:" label-for="tier">
          <b-form-select
            v-if="lookups"
            id="tier"
            v-model="form.tier"
            :options="lookups.companyTiers"
            value-field="id"
            text-field="name"
          ></b-form-select>
        </b-form-group>

        <!-- <b-button
          type="submit"
          variant="success"
          class="margin-right"
          :disabled="!validateForm()"
          ><font-awesome-icon icon="search" /> Search</b-button
        > -->
        <FeedbackButton title="Search" icon="search" :busy="isBusy" :onClick="search" class="margin-right" :disabled="!validateForm()"/>
        <b-button type="reset" variant="info"
          ><font-awesome-icon icon="eraser" /> Clear</b-button
        >
      </div>
    </b-form>

    <div class="row">
      <div class="col-sm-12">
        <SubHeader :title="'Search Results (' + this.rows + ')'" />
      </div>

      <b-table
        v-if="searchResults.length > 0"
        striped
        hover
        :items="searchResults"
        :fields="fields"
        :current-page="currentPage"
        :per-page="0"
        :busy.sync="isBusy"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        no-local-sorting
        @sort-changed="sortingChanged"
      >
        <template v-slot:cell(company)="data">
          {{ data.item.companyName }}<br />{{ data.item.postcode }}
        </template>

        <template v-slot:cell(contact)="data">
          <div>
            {{ data.item.primaryContactTitle }}
            {{ data.item.primaryContactFirstName }}
            {{ data.item.primaryContactLastName }}
          </div>
          <div v-bind:class="{ red: data.item.primaryContactTelephoneNumberCtps }">
            {{ data.item.primaryContactTelephoneNumber }}
          </div>
        </template>

        <template v-slot:cell(contacted)="data">
          <div>{{ data.item.LastContacted }}</div>
          <div>{{ data.item.LastContactedBy }}</div>
        </template>

        <template v-slot:cell(status)="data">
          <div>{{ data.item.status }}</div>
          <div>{{ data.item.owner }}</div>
          <div v-if="data.item.hasCallback">
            <strong>Callback:</strong> {{ data.item.callbackDate }}
            {{ data.item.callbackTime }}
          </div>
        </template>

        <template v-slot:cell(tier)="data">
          {{ data.item.companyTier }}
        </template>

        <template v-slot:cell(nav)="data">
          <div class="nav">
            <b-button
              block
              size="sm"
              :to="'/company/' + data.item.companyId"
              target="_blank"
              type="button"
              class="details btn btn-warning btn-xs"
            >
              <font-awesome-icon icon="edit" /> Details
            </b-button>
            <b-button size="sm" variant="success" type="button" block @click="link(data.item.companyId)">
              <font-awesome-icon icon="link" /> Link
            </b-button>
          </div>
        </template>
      </b-table>

      <b-pagination
        v-if="searchResults.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="form.perPage"
        first-number
        last-number
      ></b-pagination>
    </div>

    <b-alert v-if="searchResults.length == 0" variant="info" show
      >No Results</b-alert
    >
  </b-modal>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import FeedbackButton from "@/components/shared/FeedbackButton.vue";
import CompanyService from '@/services/Company.service';
import SearchService from '@/services/Search.service';
import DataSelectionService from "@/services/DataSelection.service";

export default {
  components: { SubHeader, FeedbackButton },
  props: {
    lookups: Object,
    companyId: String
  },
  data() {
    return {
      form: {
        companyName: "",
        vendor: "",
        companyNumber: "",
        telephoneNumber: "",
        postcode: "",
        emailAddress: "",
        status: "",
        tier: "",
        pageNo: 1,
        pageSize: 10,
        sortDirection: "",
        sortColumn: "",
      },
      searchResults: [],
      fields: [
        { key: "company", label: "Company Name", sortable: true },
        { key: "contact", label: "Primary Contact", sortable: true },
        { key: "status", label: "Status/Owner", sortable: true },
        { key: "tier", label: "Tier", sortable: true },
        { key: "nav", label: "", sortable: false },
      ],
      currentPage: 1,
      rows: 0,
      isBusy: false,
      sortBy: "",
      sortDesc: false,
      selectedCompanyId: null,
    };
  },

  watch: {
    currentPage: {
      handler: function () {
        this.form.pageNo = this.currentPage;

        this.search();
      },
    },
  },
  computed: {
    statuses() {
      if (this.lookups) {
        return [
          { id: null, name: "", followupCallback: false },
          ...this.lookups.companyStatuses,
        ];
      }

      return [{ id: null, name: "", followupCallback: false }];
    },
  },
  methods: {
    search() {
      this.isBusy = true;

      if (!this.validateForm()) return { searchResults: [], totalResults: 0 };

      SearchService.search(this.form).then(response => {
        this.searchResults = response.data.searchResults;
        this.rows = response.data.totalResults;
        this.isBusy = false;
      })
      .catch(() => {
        this.isBusy = false;
      })
    },
    async exportSearch() {
      this.isBusy = true;
      if (!this.validateForm()) return { searchResults: [], totalResults: 0 };
      const response = await this.$http.post("/search/export", this.form);
      this.isBusy = false;

      var csvElement = document.createElement("a");
      csvElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(response.data);
      csvElement.target = "_blank";
      csvElement.download = "search.csv";
      csvElement.click();
    },
    async sortingChanged(ctx) {
      switch (ctx.sortBy) {
        case "company":
          this.form.sortColumn = "CompanyName";
          break;
        case "contact":
          this.form.sortColumn = "PrimaryContactLastName";
          break;
        case "status":
          this.form.sortColumn = "Status";
          break;
        case "tier":
          this.form.sortColumn = "CompanyTier";
          break;
      }
      this.currentPage = 0;
      this.form.sortDirection = ctx.sortDesc ? "ASC" : "DESC";

      this.search();
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.search();
    },
    validateForm() {

      if (
        this.form.companyName != "" ||
        this.form.vendor != "" ||
        this.form.companyNumber != "" ||
        this.form.telephoneNumber != "" ||
        this.form.postcode != "" ||
        this.form.emailAddress != "" ||
        this.form.status != "" ||
        this.form.tier != ""
      )
        return true;

      return false;
    },
    onReset() {
      this.form = {
        companyName: "",
        vendor: "",
        companyNumber: "",
        telephoneNumber: "",
        postcode: "",
        emailAddress: "",
        status: null,
        tier: null,
        pageNo: 1,
        pageSize: 10,
        sortDirection: "",
        sortColumn: "",
      };
      this.currentPage = 1;
      this.searchResults = [];
      this.rows = 0;
    },
    showModal() {
      this.$refs["modal"].show();
    },
    hideModal() {
      this.$refs["modal"].hide();
    },

    link(linkId) {

      CompanyService.addLinkedCompany({companyId: this.companyId, linkedCompanyId: linkId}).then(() => {
        if(this.$route.name == "CompanyCall") {
            DataSelectionService.getNextCompany().then(result => {
              if(result && result.data != 0) {
                this.$router.push("/call/" + result.data);
              } else {
                this.$router.push("/getnext");
              }
            });
          } else {
          this.$parent.$parent.$parent.$parent.reloadLinkedCompanies()
          this.hideModal();
        }
      })

    },
  },
};
</script>

<style scoped>
table td {
  padding: 0.5rem !important;
}
table {
  font-size: 0.9em;
}
.nav {
  width:84px;
}
</style>
